// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { PriceType } from '@shared/utils/History/CashItemUtils';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class MI extends IndicatorScriptBase {
    constructor() {
        super();
        this.emaRation = [];
        this.ProjectName = 'Mass Index';
        this.Comments = 'Mass Index';
        this.SetIndicatorLine('mi', Color.Blue, 2, LineStyle.SimpleChart);
        this.SetLevelLine('27', 27, Color.Pink, 1, LineStyle.ShapedChart);
        this.SetLevelLine('26.5', 26.5, Color.Red, 1, LineStyle.ShapedChart);
        this.SeparateWindow = true;
        this.EmaPeriod = 9;
        super.InputParameter(new InputParameterInteger('EmaPeriod', 'Ema Period', 0, 1, 99999, 0, 1));
        this.MiPeriod = 25;
        super.InputParameter(new InputParameterInteger('MiPeriod', 'Mi Period', 0, 1, 99999, 0, 1));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
        this.UpdateIndexDrawBegin();
    }
    createInternalIndicators() {
        const hlAccessor = (offset) => {
            return (this.CurrentData.getPriceByType(PriceType.High, offset) -
                this.CurrentData.getPriceByType(PriceType.Low, offset));
        };
        this.emaHLIndicator = this.Indicators.iMAExOnArray(this.CurrentData, hlAccessor, this.EmaPeriod, MAMode.EMA, 0, 0);
        const ema1Accessor = (offset) => {
            return this.emaHLIndicator.GetValue(offset);
        };
        this.emaHLIndicator2 = this.Indicators.iMAExOnArray(this.CurrentData, ema1Accessor, this.EmaPeriod, MAMode.EMA, 0, 0);
        return [this.emaHLIndicator, this.emaHLIndicator2];
    }
    GetIndicatorShortName() {
        return 'MI(' + this.MiPeriod + ')';
    }
    getCustomName() {
        return 'MI (' + this.ProjectName + ')';
    }
    UpdateIndexDrawBegin() {
        this.SetIndexDrawBegin(0, this.MiPeriod);
    }
    OnQuote() {
        super.OnQuote();
        this.emaRation[this.emaRation.length - 1] =
            (Number.isNaN(this.emaHLIndicator.GetValue()) ? 0 : this.emaHLIndicator.GetValue()) /
                (Number.isNaN(this.emaHLIndicator2.GetValue()) ? 0 : this.emaHLIndicator2.GetValue());
        if (this.CurrentData.Count - 1 > this.MiPeriod) {
            super.SetValue(0, 0, this.emaRation.slice(-this.MiPeriod).reduce((acc, val) => acc + val));
        }
    }
    NextBar() {
        super.NextBar();
        this.emaRation.unshift(0);
    }
}
